module.exports = __webpack_public_path__ + "static/img/cg@2x.1be5c33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cg@2x.png
// module id = Hi2T
// module chunks = 1